import { Component, OnInit, ViewChild } from "@angular/core";
import { DataService } from "../../services/data.service";
import { BusinesLogicService } from "../../services/business-logic.service";
import { UtilsService } from "../../services/utils.service";
import { DatePipe } from '@angular/common';
import { HistoryComponent } from "../history/history.component";
import { ModalHelper } from "../../components/modal/modal.helper";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChatService } from "../../services/chat.service";
import { BusinessEventService } from "../../services/business-event.service";

declare var $: any;
declare var $: any;


@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.css"]
})
export class ListComponent implements OnInit {

  @ViewChild(HistoryComponent) history: HistoryComponent;

  public defaultOptions: object = {
    noShow: true,
    inWait: true,
    redirect: true,
    finished: false,
    return: true,
    inAttention: false,
    cancelled: true
  };

  public filters: object = {
    clientname: "",
    clientid: "",
    label: "",
    desk_id: "",
    prekind_id: "",
    planhour: ""
  }

  getTurnListSub: any;

  public options: object = {};

  public selectedQueue: string = null;
  public queues: any[] = [];
  public queuesnotempty: any[] = [];
  public idTurns: any[] = [];
  public cancelledTurns: any[] = [];
  public selected: number = null;
  public intervalQueue: any;
  public intervalTList: any;
  public orderType: string = null;
  public orderReverse: boolean = false;
  public columnLoaded: boolean = false;
  public printed: boolean = true;
  public tprinting: number = 0;
  public actualDate: string = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss').toString();
  public isFiltered: boolean = false;

  public socketRetries: number = 0;
  private ioConnection: any;
  private subscriptionClose: Subscription;
  private subscriptionOpen: Subscription;

  public listFilter: any = { label: '' };
  public search: string = '';

  public columns: any = {};

  private defaultColumns: any = [
    { name: "plandate", visible: false, lang: "planDate" },
    { name: "planhour", visible: true, lang: "hour" },
    { name: "label", visible: true, lang: "turn" },
    { name: "clientid", visible: true, lang: "cclient" },
    { name: "clientname", visible: true, lang: "client" },
    { name: "ccode", visible: false, lang: "ccode" },
    { name: "type", visible: false, lang: "status" },
    { name: "prekindname", visible: true, lang: "actualKind" },
    { name: "task", visible: false, lang: "task" },
    { name: "initdatetime", visible: true, lang: "ticketDate" },
    { name: "lastredirect", visible: true, lang: "redirectDate" },
    { name: "deskdatetime", visible: true, lang: "attentionDate" },
    { name: "deskname", visible: true, lang: "desk" },
    { name: "rdcomment", visible: true, lang: "observations" },
    { name: "queuename", visible: true, lang: "queue" },
    { name: "attime", visible: false, lang: "attime" },
    { name: "waittime", visible: false, lang: "waittime" }
  ];

  public visibleColumns: any = [];

  private destroy$ = new Subject();

  public sortableOptions: any = {
    onUpdate: (event: any) => {
      this.saveColumns();
    }
  };

  constructor(public _data: DataService,
    public _blogic: BusinesLogicService,
    private _modal: ModalHelper,
    public _utils: UtilsService,
    private _bevent: BusinessEventService,
    private _chat: ChatService,
    private datePipe: DatePipe) { }

  ngOnInit() {
    $(document).on("click", ".dropdown-menu", function (e) {
      e.stopPropagation();
    });
    this.initIoConnection();
    this._blogic.turnInProgress = false;

    if (localStorage.getItem("columns") != null) {
      this.columns = JSON.parse(localStorage.getItem("columns"));
    } else {
      let defaultColumns = this.defaultColumns;
      this.columns = defaultColumns;
    }

    if (localStorage.getItem("colours") != null) {
      this.options = JSON.parse(localStorage.getItem("colours"));
    } else {
      let defaultOptions = this.defaultOptions;
      this.options = defaultOptions;
    }

    if (localStorage.getItem("filters") != null) {
      this.filters = JSON.parse(localStorage.getItem("filters"));
      this.isFiltered = true;
    }

    if (localStorage.getItem("search") != null) {
      this.search = localStorage.getItem("search");
      this.searchFilter();
    }

    this.checkVisibleColumns();

    this._data.turnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: object) => {
        this.selected = null;
        this.getTurnList();
      });

    this.getQueueList();
    if (this._data.saveQueue) {
      this.getTurnList();
    }

    if (localStorage.getItem("orderType") !== null) {
      this.orderType = localStorage.getItem("orderType");
    }

    if (localStorage.getItem("orderReverse") !== null) {
      this.orderReverse = JSON.parse(localStorage.getItem("orderReverse"));
    }
  }

  clearResetIntervals() {
    /* clearInterval(this.intervalTList);

     if(this.selectedQueue)
     this.intervalTList = setInterval(() => {
       this.getTurnList();
     }, this._data.configuration["secsCheckQueue"]);*/
  }

  public initIoConnection(): void {
    if (this.socketRetries != null)
      this.socketRetries++;

    if (this.subscriptionClose != null)
      this.subscriptionClose.unsubscribe();
    if (this.subscriptionOpen != null)
      this.subscriptionOpen.unsubscribe();
    if (this.ioConnection != null)
      this.ioConnection.unsubscribe();

    this.ioConnection = this._bevent.onMessage()
      .subscribe((response: any) => {
        if (response["eventhook"] == "viewerfb") {
          this._data.turnStatusInViewer.unshift(response["message"]);
          this._data.turnStatusInViewer = this._data.turnStatusInViewer.slice(0, 100);
        }

        if (response["eventhook"] == "disconect") {
          this._data.deskInUseDeskName = response["message"]["desk_name"];
          this._data.deskInUseHostAddr = response["message"]["hostaddr"];
          this._data.deskInUseOffice = response["message"]["office"];
          this._data.deskInUseDate = response["message"]["logindate"];
          this._data.deskInUseHour = response["message"]["logintime"];
          this._data.deskInUse = true;
        }

        if (response["eventhook"] == "force_disconect") {
          this.softLogout();
        }

        if (response["eventhook"] == "turninfo") {
          this.queues = response["message"]["qinfo"];
          this.changeMode();
          if (this.selectedQueue)
            this.getTurnList();
        }

      });

    this.subscriptionOpen = this._bevent.onOpen()
      .subscribe((response: any) => { });

    this.subscriptionClose = this._bevent.onClose()
      .subscribe((response: any) => {
        this.initIoConnection();
      });
  }

  public showAlert(value) {
    this.subscriptionClose.unsubscribe();
    this.subscriptionOpen.unsubscribe();
    this.ioConnection.unsubscribe();
    this._bevent.close();

    this.socketRetries = null;
  }

  ngOnDestroy() {
    clearInterval(this.intervalQueue);
    clearInterval(this.intervalTList);

    this.destroy$.next();
    this.destroy$.complete();
  }

  /* Get queue list */
  public getQueueList(): void {
    let params: object = { filter: "queue" };
      this._blogic.getQueueList(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this._blogic.lastQueueList = response;
        this._blogic.queueInProgress = false;
        this.queues = response;
        if (this._data.saveQueue == null) {
          this.selectedQueue = null;
        } else {
          this.selectedQueue = this._data.saveQueue;
        }

        this.changeMode();
      }
      );

  }

  public printTicket(turn_id: number): void {
    this.printed = false;
    this.tprinting = turn_id;
    let params: object = { turn_id: turn_id };
    this._blogic.printTicket(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.getTurnList();
      }
      );
  }

  /* Check if work with 1 queue or more */
  public changeMode(): void {
    let split: any = this._data.session["schemaitms"].split(",");
    let allQueues: any = this.queues;
    this.queues = [];
    let count = 0;
    for (let i = 0; i < allQueues.length; i++) {

      if (split.indexOf(allQueues[i].id.toString()) !== -1) {
        this.queues.push(allQueues[i]);
        count++;
      }
    }
    this.queuesnotempty = this.queues.filter(q => q.size > 0 || q.nturns > 0);
    if (count <= 1) {
      this.selectedQueue = this.queues[0].id;
      this._data.saveQueue = this.selectedQueue;
      this.getTurnList();
    }
  }

  public getSerializedQueueList() {
    let qs = "";

    this.queues.forEach(element => {
      qs += element.id;
      qs += ",";
    });

    return qs.substr(0, qs.length - 1)
  }

  /* Get queue list */
  public getTurnList(): void {
    if (this.selectedQueue != null) {
      this._data.saveQueue = this.selectedQueue;
      let params: object = {
        queue_id: this.selectedQueue,
        session_id: this._data.session["session"]
      };

      if (this.selectedQueue == 'all')
        params["assignedQueue"] = this.getSerializedQueueList();
      else
        params["queue_id"] = this.selectedQueue;

      if (this._blogic.turnInProgress && this._blogic.lastQueueData) {
        this._blogic.turns = this.filter(this._blogic.lastQueueData);
        return;
      }



      this.getTurnListSub = this._blogic.getTurnList(params, true)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          this._blogic.lastQueueData = response;
          this._blogic.turnInProgress = false;
          this.actualDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss').toString();

          for (let e = 0; e < response.length; e++) {
            if (response[e]['lastredirect'] != null && !(typeof response[e]['lastredirect'] == 'number') && !this.isFinished(e)) {
              response[e]['lastredirect'] = this._utils.getWaitTime(response[e]['lastredirect'], this.actualDate, false, true);
            } else if (response[e]['lastredirect'] == null && !this.isFinished(response[e])) {
              response[e]['lastredirect'] = this._utils.getWaitTime(response[e]['initdatetime'], this.actualDate, false, true);
            } else if (this.isFinished(e) || this.isRedirect(e)) {
              response[e]['lastredirect'] = "0 min";
            } else { }
          }

          this._blogic.turns = this.filter(response);
          this.orderBy(this.orderType, true);
          this.printed = true;
        });
    }
  }

  public selectTurn(t): void {
    if (this.isCancelled(t)) {
      t["type"] = "cancelled";
    }

    if (this.isNoShow(t)) {
      t["type"] = "noShow";
    }

    if (this.isInWait(t)) {
      t["type"] = "inWait";
    }

    if (this.isRedirect(t)) {
      t["type"] = "redirect";
    }

    if (this.isFinished(t)) {
      t["type"] = "finished";
    }

    if (this.isInAttention(t)) {
      t["type"] = "inAttention";
    }

    if (t.fqueue_id == this.selectedQueue || t.queue_id == this.selectedQueue || this.selectedQueue == 'all') {
      this._data.selectedTurn = t;
    } else {
      this._data.selectedTurn = null;
    }
  }

  public isNoShow(t: any): boolean {
    return (
      this.options["noShow"] && (t.printed == false && t.deskdatetime == null)
    );
  }

  public isInWait(t: any): boolean {
    return (
      (this.options["inWait"] &&
      t.deskdatetime == null &&
      t.printed == true && t.canceldatetime == null &&
      (t.queue_id == this.selectedQueue || this.selectedQueue == "all")) ||
      ((t.lastredirect != null && t.queue_id == this.selectedQueue && !this.isFinished(t) && t.lqueue_id != '-1' && !this.isInAttention(t))
        && this.isCancelled(t))
    );
  }

  public isRedirect(t: any): boolean {
    return (
      this.options["redirect"] &&
      (t.lastredirect != null &&
        (t.enddatetime == null || (t.enddatetime != null && t.queue_id != this.selectedQueue && this.selectedQueue != "all")) &&
        (t.queue_id != this.selectedQueue && this.selectedQueue != "all"))
    );
  }

  public isFinished(t: any): boolean {
    return this.options["finished"] && t.enddatetime != null;
  }

  public isInAttention(t: any): boolean {
    return (
      this.options["inAttention"] && ((t.deskdatetime != null && t.enddatetime == null && t.queue_id == this.selectedQueue ) || (t.deskdatetime != null && t.enddatetime == null && this.selectedQueue == "all"))
    );
  }

  public isCancelled(t: any): boolean {
    return (
      this.options["cancelled"] && t.deskdatetime == null && t.printed == true && t.canceldatetime != null
    );
  }

  public getVisibleColums(): any {
    return this.columns.filter(c => c.visible == true);
  }

  public getFirstVisibleColum(): any {
    let vcolums = this.getVisibleColums();
    return (vcolums) ? vcolums[0] : null;
  }

  public checkColumsVisible(type: string): boolean {
    let c = this.columns.filter(c => c.visible == true && c.name == type);
    return c ? true : false;
  }

  public orderBy(type: string, onlyRefresh = false): void {

    this.orderType = type;
    localStorage.setItem("orderType", type);

    if (!onlyRefresh) {
      this.orderReverse = !this.orderReverse;
    }
    localStorage.setItem("orderReverse", JSON.stringify(this.orderReverse));
  }

  public saveColumns(): void {
    localStorage.setItem("columns", JSON.stringify(this.columns));
    this.checkVisibleColumns();
  }

  public saveOptions(): void {
    localStorage.setItem("colours", JSON.stringify(this.options));
  }

  public resetColumns(): void {
    localStorage.removeItem("columns");
    localStorage.removeItem("colours");
    this.ngOnInit();
    location.reload();
  }

  /* Hace un listado con las diferentes columnas visibles para poder renderizarlas correctamente en la tabla */
  public checkVisibleColumns(): void {
    this.visibleColumns = [];
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].visible == true) {
        this.visibleColumns.push(this.columns[i].name);
      }
    }
    this.columnLoaded = true;
  }

  public filter(list: Array<object>) {
    for (var key in this.filters) {
      if (this.filters.hasOwnProperty(key) && this.filters[key] != null && this.filters[key].length != 0) {

        switch (key) {
          case 'desk_id':
            this.filters[key] = parseInt(this.filters[key]);
            list = list.filter(q => q[key] == this.filters[key]);
            break;
          case 'prekind_id':
            this.filters[key] = parseInt(this.filters[key]);
            list = list.filter(q => q[key] == this.filters[key]);
            break;
          default:
            list = list.filter(q => q[key] == this.filters[key]);
            break;
        }


      }
    }
    return list;
  }

  public openModalFilter() {
    this._modal.show('filterModal');
  }

  public applyFilters(event: any) {
    this.filters["clientname"] = event.target.clientname.value;
    this.filters["clientid"] = event.target.clientid.value;
    this.filters["label"] = event.target.label.value;
    this.filters["desk_id"] = event.target.desk_id.value;
    this.filters["prekind_id"] = event.target.prekind_id.value;
    this.filters["planhour"] = event.target.planhour.value;

    localStorage.setItem("filters", JSON.stringify(this.filters));
    this.isFiltered = true;
    this.getTurnList();

    this._modal.hide("filterModal");
  }

  public clearFilters() {
    this.filters = {
      clientname: "",
      clientid: "",
      label: "",
      desk_id: "",
      prekind_id: "",
      planhour: ""
    };

    this.isFiltered = false;

    localStorage.removeItem("filters");
    this.getTurnList();
    this._modal.hide("filterModal");
  }

  searchFilter() {
    this.listFilter = {
      $or: [{ label: this.search }, { clientid: this.search }, { clientname: this.search }, { planhour: this.search },
      { ccode: this.search }, { type: this.search }, { prekindname: this.search }, { task: this.search }, { initdatetime: this.search },
      { lastredirect: this.search }, { deskdatetime: this.search }, { deskname: this.search }, { rdcomment: this.search }
      ]
    };

    localStorage.setItem("search", this.search);
  }

  removeSearch() {
    this.search = "";
    localStorage.removeItem("search");
    this.searchFilter();
  }

  public softLogout() {

    if (this.subscriptionClose != null)
      this.subscriptionClose.unsubscribe();
    if (this.subscriptionOpen != null)
      this.subscriptionOpen.unsubscribe();
    if (this.ioConnection != null)
      this.ioConnection.unsubscribe();

    this._bevent.close();
    this._chat.close();

    this._data.timeExceed = true;
  }

}
